<template>
  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item NewsDK">
      <div class="tit">
        <h3>
          송원문화재단
          <span>최신 소식입니다</span>
        </h3>
      </div>
      <div class="News_tit News_bottom_p">
        <h4>{{ detail.title }}</h4>
        <p class="day">{{ detail.createdAt | date }}</p>

      </div>
      <div class="txt">
          <div class="ql-editor" v-html="detail.content"></div>


          <div v-if="detail.files != undefined &&  detail.files.dnFiles != undefined && detail.files.dnFiles.length != 0">
            <div class="bnt_area" v-for="(obj, index) in detail.files.dnFiles" :key="index">
              <button class="btn_download" @click="nasDownload(obj.filename)">{{ obj.originalname }}</button>
            </div>
          </div>
        </div>

      <div class="News_btn_area">
        <button class="btn_list" @click="btnGoList">목록</button>
        <button class="btn_list fl mgr10" v-if="isAdmin" @click="btnUpdate">수정</button>
        <button class="btn_list type01 fl" v-if="isAdmin" @click="btnDelete">삭제</button>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";




export default {
  data: () => ({
    message: "BoardDetail.vue",
    isAdmin: false,
    detail: {
      createdAt: "",
      title: "",
      content: "",
      startDt: "",
      endtDt: "",
      files: {}
    }
  }),
  methods: {
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log("checkAdmin - ok");
          this.isAdmin = true;
        })
        .catch(err => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },
    btnUpdate() {
      console.log("btnUpdate");
      this.$router.replace({
        path: `/notice/NoticeWritePopup`,
        query: {
          id: this.$route.query.id,
          // 게시판 타입 = 0 : 공지사항, 1 : 소식,
          type: this.$route.query.type,
        }

      });

    },
    btnGoList() {
      console.log("btnGoList");
      history.back();
    },
    btnDelete() {
      console.log("btnDelete");

      if (confirm("정말 삭제하시겠습니까?")) {
        let url = "deleteNotice";
        let params = {
          id: this.$route.query.id
        };
        pm.post(url, params)
          .then(result => {
            console.log("btnDelete ok");
            eventBus.$emit("EVENT_CHANGE_BOARD_LIST");
            alert("삭제되었습니다.");


            this.$router.replace("/");
          })
          .catch(err => {
            console.log("btnDelete err");
            alert("삭제 실패");
          });

        //   pm.post
      }
    },
    reqDetail() {
      let url = `noticeDetail?id=${this.$route.query.id}`;
      console.log("URL===="+ url);

      pm.get(url)
        .then(result => {
          console.log("noticeDetail - ok");
          this.detail = result.detail;
        })
        .catch(err => {
          console.log("noticeDetail - error");
        });
    }
  },
  computed: {
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  destroyed() {
    eventBus.$off("EVENT_CHANGE_NEWS_DETAIL");
  },
  created() {
    console.log("created - " + this.message);

    if (this.$route.query.id) {
      console.log("this.$route.query.boardId = " + this.$route.query.id);
    }

    if (this.$route.query.type) {
      console.log('this.$route.query.type = ' + this.$route.query.type);
    }

    this.reqDetail();
    if (localStorage.authToken) {
      this.checkAdmin();
    }

    eventBus.$on("EVENT_CHANGE_NEWS_DETAIL", () => {
      console.log("EVENT_CHANGE_NEWS_DETAIL");
      this.reqDetail();
    });
  }
};
</script>


<style scoped>
/* @import url('https://cdn.quilljs.com/1.3.7/quill.core.css'); */

</style>




// WEBPACK FOOTER //
// src/components/sub02/BoardDetail.vue